export default "__VITE_ASSET__ClBctP0x__"